<template>
    <div class="dashboard-charts">
        <h2 class="heading">
            {{ graphHeading }}
        </h2>
        <base-table-spinner v-show="showSpinner"></base-table-spinner>
        <div v-show="!noRecordFound && !showSpinner" class="chart-container">
            <div :id="id" class="amcharts-div activity-timeline-report"></div>
        </div>

        <base-no-record-found v-show="noRecordFound"></base-no-record-found>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import resource from '@/api/resource'
require('amcharts3')
require('amcharts3/amcharts/serial')
require('amcharts3/amcharts/pie')

export default {
    // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        id: {
            type: String,
            default: null,
        },
        path: {
            type: String,
            required: true,
        },
        query: {
            type: Object,
            required: true,
        },
        reset: {
            type: Number,
            default: 0,
        },
        graphHeading: {
            type: String,
            required: true,
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            dataProvider: [],
            resourceApi: null,
            noRecordFound: false,
            showSpinner: true,
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        reset(value) {
            if (value) {
                this.getStats()
            }
        },
        dataSegmentId(value) {
            if (value) {
                this.noRecordFound = false
                this.showSpinner = true
                this.getStats()
            }
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getStats()
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > created
    |--------------------------------------------------------------------------
    */
    created() {
        this.resourceApi = new resource(this.path)
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        created() {
            window.AmCharts.makeChart(this.id, {
                type: 'serial',
                categoryField: 'category',
                categoryType1: 'category-type-1',
                categoryType2: 'category-type-2',
                rotate: false,
                colors: [
                    '#C91F37',
                    '#1B1B1E',
                    '#B0DE09',
                    '#0D8ECF',
                    '#2A0CD0',
                    '#CD0D74',
                    '#CC0000',
                    '#00CC00',
                    '#0000CC',
                    '#DDDDDD',
                    '#999999',
                    '#333333',
                    '#990000',
                ],
                startDuration: 1,
                color: '#1B1B1E',
                fontFamily: 'ProximanovaRegular',
                fontSize: 14,
                categoryAxis: {
                    autoWrap: true,
                    gridPosition: 'start',
                    gridAlpha: 1,
                    gridColor: '#F2F2F6',
                },
                trendLines: [],
                graphs: [
                    {
                        balloonText: '[[category-type-1]]: [[value]]',
                        fillAlphas: 1,
                        id: 'AmGraph-1',
                        title: 'graph 1',
                        type: 'column',
                        valueField: 'column-1',
                    },
                    {
                        balloonText: '[[category-type-2]]: [[value]]',
                        fillAlphas: 1,
                        id: 'AmGraph-2',
                        title: 'graph 2',
                        type: 'column',
                        valueField: 'column-2',
                    },
                ],
                guides: [],
                valueAxes: [
                    {
                        id: 'ValueAxis-1',
                        gridAlpha: 1,
                        gridColor: '#F2F2F6',
                        title: '',
                    },
                ],
                allLabels: [],
                balloon: {},
                titles: [],
                dataProvider: this.dataProvider,
            })
        }, // created() method end

        async getStats() {
            try {
                this.query.dataSegmentId = this.dataSegmentId
                    ? this.dataSegmentId
                    : localStorage.getItem('activeDataSegmentId')
                let { data } = await this.resourceApi.list(this.query)
                this.showSpinner = false
                if (data && data.data) {
                    this.dataProvider = []
                    if (data.data.length) {
                        let graphData = data.data
                        this.noRecordFound = false
                        for (var k in graphData) {
                            let count = 0
                            let otherCount = 0
                            if (
                                graphData[k].hasOwnProperty(
                                    'nameScreeningStatus'
                                )
                            ) {
                                _.filter(
                                    graphData[k]['nameScreeningStatus'],
                                    function (val) {
                                        if (val.group !== 'sanction') {
                                            count += val.count
                                        } else {
                                            otherCount += val.count
                                        }
                                    }
                                )
                                this.dataProvider.push({
                                    category: 'Name Screening Hit',
                                    'category-type-1': 'Sanction hit',
                                    'category-type-2':
                                        'PEP, Enforcement or Black list hit',
                                    'column-1': count,
                                    'column-2': otherCount,
                                })
                            }
                            if (
                                graphData[k].hasOwnProperty(
                                    'documentationStatus'
                                )
                            ) {
                                _.filter(
                                    graphData[k]['documentationStatus'],
                                    function (val) {
                                        if (val.group == 'expired') {
                                            count += val.count
                                        } else {
                                            otherCount += val.count
                                        }
                                    }
                                )
                                this.dataProvider.push({
                                    category: 'Document Verification Hit ',
                                    'category-type-1':
                                        ' Documents nearing expiry',
                                    'category-type-2': 'Documents mismatched.',
                                    'column-1': count,
                                    'column-2': otherCount,
                                })
                            }
                            if (
                                graphData[k].hasOwnProperty('riskRatingStatus')
                            ) {
                                _.filter(
                                    graphData[k]['riskRatingStatus'],
                                    function (val) {
                                        if (val.group !== 'periodic_review') {
                                            count += val.count
                                        } else {
                                            otherCount += val.count
                                        }
                                    }
                                )
                                this.dataProvider.push({
                                    category: 'Risk rating hit',
                                    'category-type-1': 'Periodic Review due',
                                    'category-type-2':
                                        'High Risk or Sanctioned',
                                    'column-1': count,
                                    'column-2': otherCount,
                                })
                            }
                        }
                    } else {
                        this.noRecordFound = true
                    }
                } else {
                    this.noRecordFound = true
                }

                this.created()
            } catch (error) {
                //console.log(error)
                this.$store.commit('setError', error)
            }
        }, // getStats() methods end
    }, // End of Component > created
} // End of export default
</script>
